import React from 'react';
import listIcon1 from '../assets/list-icon1.svg';
import listIcon2 from '../assets/list-icon2.svg';
import listIcon3 from '../assets/list-icon3.svg';
import listIcon4 from '../assets/list-icon4.svg';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function EasyCreditBenefit() {
    const { t } = useTranslation();
    return (
        <Box className="creditBenefitContainer" >
            <Box className="mb-2">
                <Box className="cred-flex" >
                    <img src={listIcon1} alt="Logo" />
                    <div className='textLeft' >
                        <span className="cred-fontStyle" >
                            {t('benefits.anytimeAnywhere')}
                        </span>
                        <br />
                        <span className='cred-desc-style' >
                            {t('benefits.anytimeAnywhereDesc')}
                        </span>
                    </div>
                </Box>
            </Box>
            <Box className="mb-2">
                <Box className="cred-flex" >
                    <img src={listIcon2} alt="Logo" />
                    <div className='textLeft' >
                        <span className="cred-fontStyle" >
                            {t('benefits.seeCreditDetails')}
                        </span>
                        <br />
                        <span className='cred-desc-style' >
                            {t('benefits.seeCreditDetailsDesc')}
                        </span>
                    </div>
                </Box>
            </Box>
            <Box className="mb-2" >
                <Box className="cred-flex" >
                    <img src={listIcon3} alt="Logo" />
                    <div className='textLeft'>
                        <span className="cred-fontStyle" >
                            {t('benefits.skipQueues')}
                        </span>
                        <br />
                        <span className='cred-desc-style' >
                            {t('benefits.skipQueuesDesc')}
                        </span>
                    </div>
                </Box>
            </Box>
            <Box className="mb-2">
                <Box className="cred-flex" >
                    <img src={listIcon4} alt="Logo" />
                    <div className='textLeft'>
                        <span className="cred-fontStyle" >
                            {t('benefits.zeroCharges')}
                        </span>
                        <br />
                        <span className='cred-desc-style' >
                            {t('benefits.zeroChargesDesc')}
                        </span>
                    </div>
                </Box>
            </Box>
        </Box>
    )
}

export default EasyCreditBenefit;
